// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as Recti$Linear from "lumi-linear/lib/es6/src/Recti.res.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";
import * as Prelude$LumiCentral from "./Prelude.res.js";
import * as Sensor$LumiDocuments from "lumi-documents/lib/es6/src/Sensor.res.js";
import * as Occupation$LumiDocuments from "lumi-documents/lib/es6/src/Occupation.res.js";
import * as OccupationSnapshot$LumiDocuments from "lumi-documents/lib/es6/src/OccupationSnapshot.res.js";

let jsonCodec = Jzon.object4(param => [
  param.snapshot,
  param.creationTime,
  param.imageUrl,
  param.placeAABB
], param => ({
  TAG: "Ok",
  _0: {
    snapshot: param[0],
    creationTime: param[1],
    imageUrl: param[2],
    placeAABB: param[3]
  }
}), Jzon.field("snapshot", OccupationSnapshot$LumiDocuments.jsonCodec), Jzon.field("creationTime", LumiDate.DateTime.jsonCodec), Jzon.field("imageUrl", Jzon.string), Jzon.field("placeAABB", Recti$Linear.jsonCodec));

let OccupationDetailsSnapshot = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object3(param => [
  param.occupation,
  param.oldestSnapshot,
  param.latestSnapshot
], param => ({
  TAG: "Ok",
  _0: {
    occupation: param[0],
    oldestSnapshot: param[1],
    latestSnapshot: param[2]
  }
}), Jzon.field("occupation", Prelude$LumiCentral.documentCodec(Occupation$LumiDocuments.Occupation.jsonCodec)), Jzon.field("oldestSnapshot", Jzon.nullable(jsonCodec)), Jzon.field("latestSnapshot", Jzon.nullable(jsonCodec)));

let OccupationDetails = {
  jsonCodec: jsonCodec$1
};

let jsonCodec$2 = Jzon.object3(param => [
  param.sensor,
  param.occupations,
  param.currentOccupation
], param => ({
  TAG: "Ok",
  _0: {
    sensor: param[0],
    occupations: param[1],
    currentOccupation: param[2]
  }
}), Jzon.field("sensor", Sensor$LumiDocuments.Sensor.jsonCodec), Jzon.field("occupations", Jzon.array(jsonCodec$1)), Jzon.field("currentOccupation", Jzon.nullable(Document$LumiStore.Key.jsonCodec())));

let OccupationHistory = {
  jsonCodec: jsonCodec$2
};

export {
  OccupationDetailsSnapshot,
  OccupationDetails,
  OccupationHistory,
}
/* jsonCodec Not a pure module */
